import { ExceptWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Except')
export class ExceptConnectorProvider extends ConnectorProvider<ExceptWorkflowNode> {}
